import {useContext} from 'react';
import {TooltipContext} from './tooltipContext';

export const useTooltip = () => {
    const {showTooltip, dismissTooltip, setNavigation} = useContext(TooltipContext);
    return {showTooltip, dismissTooltip, setNavigation};
};

export * from './tooltipContext';
